import { createContext, useCallback, useContext, useMemo, useState } from 'react'
import { BusinessAPI } from '../../../../../../api/business.api'
import { OrganizationAPI } from '../../../../../../api/organization.api'

// Solo los formularios dentro de la conciliación notifican sus creaciones.
export const LinkageCreationContext = createContext(null)

export const useLinkageAmount = (initialValue = '') => {
  const context = useContext(LinkageCreationContext)
  const [value, setValue] = useState(initialValue)
  const rawAmount = context?.bankAmount
  const locked = Boolean(context) && rawAmount != null && Number.isFinite(Number(rawAmount))
  const setAmount = useCallback(next => {
    if (!locked) setValue(next)
  }, [locked])
  return [locked ? String(Math.abs(Number(rawAmount))) : value, setAmount, locked]
}

export const useLinkageRepetition = () => {
  const context = useContext(LinkageCreationContext)
  const [value, setValue] = useState(false)
  const setRepeat = useCallback(next => {
    if (!context) setValue(next)
  }, [context])
  return [context ? false : value, setRepeat]
}

export const useLinkageBusinessAPI = () => {
  const context = useContext(LinkageCreationContext)
  const runCreation = typeof context === 'function' ? context : context?.runCreation
  return useMemo(() => {
    const api = new BusinessAPI()
    if (!runCreation) return api
    const create = api.postPagoArriendo.bind(api)
    api.postPagoArriendo = (businessId, payload, model = 'pago-arriendo') =>
      runCreation(() => create(businessId, payload, model), { payload, model })
    const upload = api.uploadRendicionGastosExcel.bind(api)
    api.uploadRendicionGastosExcel = (businessId, file) =>
      runCreation(() => upload(businessId, file), { model: 'rendicion-gastos' })
    const uploadModel = api.uploadModelLibroExcel
    api.uploadModelLibroExcel = (businessId, payload, model, cuenta, monto) =>
      runCreation(() => uploadModel.call(api, businessId, payload, model, cuenta, monto), { model })
    return api
  }, [runCreation])
}

export const useLinkageOrganizationAPI = () => {
  const context = useContext(LinkageCreationContext)
  const runCreation = typeof context === 'function' ? context : context?.runCreation
  return useMemo(() => {
    const api = new OrganizationAPI()
    if (!runCreation) return api
    const create = api.postCajaMultiple.bind(api)
    api.postCajaMultiple = (params, payload) =>
      runCreation(() => create(params, payload), { model: 'caja-multiple' })
    return api
  }, [runCreation])
}
